import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "antd";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import CustomTable from "../../components/styledComponent/styledTable";
import { ShowNotification } from "../../components/notification/notification";
import { useAppContext } from "../../contexts/appContext";
import {
  getCategoryDetails,
  getProductByCategoryId,
} from "../../server/categoryServices";

export default function CategoryDetails() {
  const productColumn = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "30%",
      ellipsis: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchase_rate",
      key: "purchase_rate",
      width: "10%",
    },
    {
      title: "MRP",
      dataIndex: "mrp",
      key: "mrp",
      width: "10%",
    },
  ];
  const { startLoading, stopLoading, user } = useAppContext();
  const { id } = useParams();
  const navigate = useNavigate();

  const [refetch, setRefetch] = useState(false);
  const [categoryData, setCategoryData] = useState();
  const [productData, setProductData] = useState([]);
  var userRole = user?.role;
  var quotationPermission = user?.access?.Category;
  const fetchCategoryDetails = async () => {
    startLoading();
    try {
      let res = await getCategoryDetails(id);
      if (!res.data) {
        ShowNotification({ type: "error", message: "Category not Found" });
        navigate("/category");
      } else {
        setCategoryData(res.data);
        fetchProdctByCategoryId();
      }
      setRefetch(false);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchProdctByCategoryId = async () => {
    startLoading();
    try {
      let res = await getProductByCategoryId(id);
      if (res.data) {
        setProductData(
          res.data.map((val) => ({
            ...val.product,
          }))
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      stopLoading();
    }
  };

  const handleOnImportClick = () => {
    // setShowImportModal(true);
    console.log("Import");
  };
  useEffect(() => {
    fetchCategoryDetails();
  }, [refetch]);

  return (
    <div>
      <StyledContentCard title={"Category Details"}>
        <Row className="my-4">
          <Col span={6}>
            <div className="details-key">Category Name</div>
            <div className="details-value">
              {categoryData && categoryData.name ? categoryData.name : "-"}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Category Name in Arabic</div>
            <div className="details-value">
              {categoryData && categoryData.name_arabic
                ? categoryData.name_arabic
                : "-"}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Parent Id</div>
            <div className="details-value">
              {categoryData && categoryData.parent_id
                ? categoryData.parent_id
                : "-"}
            </div>
          </Col>
        </Row>
        <CustomTable
          columns={productColumn}
          data={productData}
          pageSize={25}
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/product/${record.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}
